<template>
	<pp-modal v-model="showModal" on-visible-change="modelchange" :closable="clos" :mask-closable="false" width="600">
		<p slot="header" class="modalHead">
			<span>{{ modalheader }}</span>
		</p>
		<!-- 特殊渠道需要补充资料 9869需求-->
		<div v-if="isKbankAlternativeRefund" class="modalContent">
			<p style="margin-bottom: 20px; font-weight: 500;">
				{{ $t('webList.webDetail.tips') }}
			</p>
			<el-form
				ref="notOriginalForm"
				:inline="true"
				label-position="left"
				label-width="155px"
				class="formstyle"
				:model="notOriginalForm"
				:rules="rules"
			>
				<el-form-item prop="bankCode" :label="$t('webList.webDetail.bankName')">
					<el-select v-model="notOriginalForm.bankCode" filterable class="inputstyle">
						<el-option
							v-for="(bank, index) in bankList"
							:key="index"
							:label="bank.label"
							:value="bank.value"
						/>
					</el-select>
					<el-tooltip :content="$t('webList.webDetail.tips2')" placement="bottom">
						<i class="el-icon-info" style="color: #999;margin-left: 5px;cursor: pointer;" />
					</el-tooltip>
					<!-- <span style="font-size: 12px;color: #999;margin-left: 5px;">
						<i class="el-icon-info" /> {{ $t('webList.webDetail.tips2') }}
					</span> -->

				</el-form-item>
				<el-form-item prop="accountName" :label="$t('webList.webDetail.accountName')">
					<el-input v-model=" notOriginalForm.accountName" type="text" class="inputstyle" />
				</el-form-item>
				<el-form-item prop="accountNumber" :label="$t('webList.webDetail.accountNumber')">
					<el-input v-model="notOriginalForm.accountNumber" type="text" class="inputstyle" />
				</el-form-item>

				<el-form-item
					v-if="cardType === 'SCB' || cardType ==='KMA'"
					prop="tradeVoucherId"
					:label="$t('webList.webDetail.tradeVoucherId')"
				>

					<div style="display: flex; align-items: center;">
						<el-input v-model="notOriginalForm.tradeVoucherId" type="text" class="inputstyle" />
						<el-tooltip :content="$t('webList.webDetail.tradeVoucherIdSample')" placement="bottom">
							<i class="el-icon-info" style="color: #999;margin-left: 5px;cursor: pointer;" />
						</el-tooltip>
					</div>

				</el-form-item>
				<el-form-item prop="fileList" :label="$t('webList.webDetail.paymentSlip')">
					<images-upload v-model="notOriginalForm.fileList" :pay-request-id="transactionId" :limit="3" :max-size="3" />
				</el-form-item>
			</el-form>
			<div style="font-size: 12px;color: #999;margin-left: 5px;">
				<!-- TODO:下载凭证 -->
				<i class="el-icon-info" />
				{{ $t('webList.webDetail.paymentSlipSample') }} <span
					style="color: #40ADFF;cursor: pointer;"
					@click="downloadImages"
				>{{
					$t('webList.webDetail.downloadPaymentSlip') }}</span>
			</div>
		</div>
		<!-- 原来逻辑不改变 -->
		<div v-else class="modalContent">
			<p>{{ modalcontent }} {{ currency }} {{ $filters.money(amount) }}</p>
			<div>
				<pp-row>
					<pp-col :span="12">
						<pp-form ref="formCustom" class="formstyle" :model="formCustom" :rules="rules">
							<pp-form-item prop="confirmAmount" class="control-input">
								<pp-input
									v-model.trim="formCustom.confirmAmount"
									:value="formCustom.confirmAmount"
									type="text"
									:placeholder="currency"
									class="inputstyle"
								/>
							</pp-form-item>
						</pp-form>
					</pp-col>
					<pp-col :span="12">
						<div class="all" @click="getAllAmount">{{ $t('webList.webDetail.allFunds') }}</div>
					</pp-col>
				</pp-row>
				<p style="color: #999;">
					{{ $t('webList.tradeDetail.refundTips1st') }}
					<br>
					{{ $t('webList.tradeDetail.refundTips2nd') }}
				</p>
				<!-- 非原路退款 -->
				<div v-if="refundType === 'NONE'" class="not-original-refund">
					<p style="color: #999;margin-bottom: 16px;">{{ $t('webList.tradeDetail.refundTips3nd') }}</p>
					<el-form
						ref="notOriginalForm"
						:inline="true"
						label-position="left"
						label-width="150px"
						class="formstyle"
						:model="notOriginalForm"
						:rules="rules"
					>
						<template v-for="(item, index) in notOriginalConfig">
							<el-form-item :key="index" :prop="item.prop" :label="item.label">
								<el-input
									v-if="item.type === 'text'"
									v-model="notOriginalForm[item.prop]"
									type="text"
									class="inputstyle"
								/>

								<el-select
									v-else-if="item.type === 'select'"
									v-model="notOriginalForm[item.prop]"
									filterable
									class="inputstyle"
								>
									<el-option
										v-for="(list, index) in item.options"
										:key="index"
										:label="list"
										:value="list"
									/>
								</el-select>
							</el-form-item>
						</template>
					</el-form>
				</div>
			</div>
		</div>
		<div slot="footer">
			<pp-button type="primary" size="spec" :loading="loading2" @click="commit()">{{
				$t('webList.webDetail.confirm') }}</pp-button>
			<!-- <pp-button type="primary" size="small" @click="rightFun">{{rightbtn}}</pp-button> -->
		</div>
	</pp-modal>
</template>

<script>
import imagesUpload from '@/components/upload/returnImagesUpload.vue'

import {
	createNamespacedHelpers
} from 'vuex'

const {
	mapGetters: webMapGetters,
	mapActions: webMapActions
} = createNamespacedHelpers('website')
import { getXManPayBank, getKBanKPayBank } from '@/api/modules/webSiteApi'
export default {
	name: 'CancleModal',
	components: {
		imagesUpload
	},
	props: {
		modalcontent: '',
		modalheader: '',
		currency: '',
		tradeId: '',
		amount: '',
		accId: '',
		clientId: '',
		orderId: '',
		params: '',
		transactionId: '',
		refundType: '',
		gateway: '',
		cardType: '',
		flowId: '',
		isKbankAlternativeRefund: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loading2: false,
			clos: true,
			showModal: false,
			rules: {
				confirmAmount: [{
					required: true,
					trigger: 'blur',
					validator: (rule, value, callback) => {
						this.formCustom.confirmAmount = this.$filters.pureMoney(this.formCustom.confirmAmount)
						// Number(this.formCustom.confirmAmount).toFixed(2);
					}
				}],
				accountName: [{ required: true, message: 'this field is required' }],
				accountNumber: [{ required: true, message: 'this field is required' }],
				bankCode: [{ required: true, message: 'this field is required' }],
				accountType: [{ required: true, message: 'this field is required' }],
				accountHolder: [{ required: true, message: 'this field is required' }],
				customerName: [{ required: true, message: 'this field is required' }],
				email: [
					{ required: true, message: 'this field is required' },
					{ type: 'email', message: 'Email address format is incorrect', trigger: ['blur', 'change'] }
				],
				tradeVoucherId: [{ required: this.cardType === 'SCB' || this.cardType === 'KMA', message: 'this field is required' }],
				phone: [{ required: true, message: 'this field is required' }],
				fileList: [{ required: this.isKbankAlternativeRefund, message: 'this field is required' }]
			},
			formCustom: {
				confirmAmount: ''
			},
			notOriginalForm: {
				accountName: '',
				accountNumber: '',
				bankCode: '',
				fileList: [] // 上传凭证
			},
			xManPayBank: [],
			bankList: []
		}
	},
	computed: {
		...webMapGetters(['returnTradeRes']),
		notOriginalConfig() {
			if (this.gateway === 'XManPay') {
				const commonConfig = [
					{
						type: 'select',
						prop: 'accountType',
						label: this.$t('webList.tradeChannelRefund.accountType'),
						options: ['BANK_ACCOUNT', 'MOBILE_NO', 'NATIONAL_ID']
					},
					{
						type: 'select',
						prop: 'bankCode',
						label: this.$t('webList.tradeChannelRefund.accountName'),
						options: this.xManPayBank
					},
					{
						type: 'text',
						prop: 'accountName',
						label: this.$t('webList.tradeChannelRefund.accountHolder')
					}
				]
				const type = this.notOriginalForm.accountType
				if (!type) return commonConfig
				const map = {
					BANK_ACCOUNT: 'accountNumber',
					MOBILE_NO: 'phoneNo',
					NATIONAL_ID: 'nationalId'
				}
				const key = map[type]
				if (key) {
					commonConfig.push({
						type: 'text',
						prop: 'accountNumber',
						label: this.$t(`webList.tradeChannelRefund.${key}`)
					})
				}
				return commonConfig
			} else if (this.gateway === 'Jokul' || this.gateway === 'JokulQris') {
				return [
					{
						type: 'text',
						prop: 'email',
						label: this.$t('webList.tradeChannelRefund.email')
					},
					{
						type: 'text',
						prop: 'phone',
						label: this.$t('webList.tradeChannelRefund.phoneNo')
					},
					{
						type: 'text',
						prop: 'customerName',
						label: this.$t('webList.tradeChannelRefund.accountHolder')
					}
				]
			} else {
				return [
					{
						type: 'text',
						prop: 'accountName',
						label: this.$t('webList.tradeDetail.accountName')
					},
					{
						type: 'text',
						prop: 'accountNumber',
						label: this.$t('webList.tradeDetail.accountNumber')
					},
					{
						type: 'text',
						prop: 'bankCode',
						label: this.$t('webList.tradeDetail.bankCode')
					}
				]
			}
		}
	},
	// mounted() {
	// 	// X-Man 渠道下且为非原路退款时, 获取 X-Man 银行列表
	// 	if (this.gateway === 'XManPay' && this.refundType === 'NONE') {
	// 		this.getXManPayBank()
	// 	}
	// },
	mounted() {
		// X-Man 渠道下且为非原路退款时, 获取 X-Man 银行列表
		if (this.gateway === 'XManPay' && this.refundType === 'NONE') {
			this.getXManPayBank()
		}
		// KBank 渠道下, 获取 KBank 银行列表
		if (this.isKbankAlternativeRefund) {
			getKBanKPayBank().then(res => {
				const result = Object.entries(res).map(([key, value]) => ({
					label: key,
					value: value
				}))
				this.bankList = result
			})
		}
	},
	methods: {
		...webMapActions([
			'returnTrade' // 获取交易详情
		]),

		downloadImages() {
			const urls = [
				'https://cdn17.pingpongx.com/static_platform/acquirer/pay-front/KMA%20sample.jpg',
				'https://cdn17.pingpongx.com/static_platform/acquirer/pay-front/KTB%20sample.jpeg',
				'https://cdn17.pingpongx.com/static_platform/acquirer/pay-front/SCB%20sample.png'
			]
			urls.forEach((url, i) => {
				setTimeout(() => {
					const a = document.createElement('a')
					a.href = url
					a.download = ''
					a.setAttribute('target', '_blank')
					a.click()
				}, i * 200) // 间隔200ms，避免浏览器拦截
			})
		},
		getAllAmount() {
			this.formCustom.confirmAmount = this.$filters.pureMoney(this.amount) // Number(this.amount).toFixed(2);
		},
		show() {
			this.showModal = true
			this.formCustom.confirmAmount = ''
		},
		cancle() {
			this.showModal = false
		},
		commit() {
			// THKbank渠道默认全额退款
			const value = this.isKbankAlternativeRefund ? this.amount : Number(this.formCustom.confirmAmount)
			const amount = Number(this.amount)
			if (value > amount) {
				this.$message.error(this.$t('webList.withdrawModal.refundRule'))
				return false
			} else {
				const amountReg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
				var reg = amountReg.test(value)
				if (reg) {
					this.confirmfun()
				} else {
					this.$message.error(this.$t('webList.withdrawModal.formRules2'))
					return false
				}
			}
		},
		// 获取初始化交易记录数据
		async confirmfun() {
			this.clos = false
			let params = {
				accId: this.params.accId,
				clientId: this.params.clientId,
				transactionId: this.transactionId,
				orderId: this.orderId,
				currency: this.currency,
				refundAmount: this.isKbankAlternativeRefund ? this.amount : this.formCustom.confirmAmount,
				type: 'ACI'
			}
			// 非原路径退款
			if (this.refundType === 'NONE') {
				const valid = await this.$refs['notOriginalForm'].validate()
				if (!valid) return
				const fileList = this.isKbankAlternativeRefund && this.notOriginalForm.fileList.map(item => item.fileId) || []
				params = {
					...params,
					...this.notOriginalForm,
					fileList: fileList.join(',')

				}
			}
			this.loading2 = true
			await this.returnTrade(params)
			setTimeout(() => {
				this.clos = true
				this.loading2 = false
				if (this.returnTradeRes) {
					this.$message.success(this.$t('webList.withdrawModal.success'))
					this.$emit('finish')
					this.showModal = false
					this.formCustom.confirmAmount = ''
				}
			}, 3000)
		},
		async getXManPayBank() {
			const res = await getXManPayBank()
			this.xManPayBank = res || []
		}
	}

}
</script>

<style lang="scss" scoped>
.modalHead {
	color: #000;
	font-size: 20px;
	text-align: left;
}

.modalContent {
	text-align: left;
	font-size: 14px;
    .not-original-refund .inputstyle {
        width: 270px;
    }
}

.control-input {
	margin: 20px 0;
	width: 200px;
	span {
		display: block;
		float: left;
	}
}
.all {
	width: 200px;
	height: 76px;
	line-height: 76px;
	cursor: pointer;
	color: #1fa0e8;
}
</style>
